<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:0px;">
      <el-row>
        <el-col :span="12">
          <div>
            <span class="bold"></span>
            <span class="basic">模板数据</span>
          </div>
        </el-col>
        <el-col :span="12" style="text-align:right;">
          <el-button type="primary" @click="onEdit" v-if="!isBtnShow">编辑</el-button>
          <el-button type="primary" plain @click="onSave" v-else>保存</el-button>
          <el-button type="primary" plain @click="onBinding">绑定客户</el-button>
        </el-col>
      </el-row>
      <el-form label-width="110px" :rules="rules" :model="queryParams" ref="queryParamsRefs">
        <el-row>
          <el-col :span="8">
            <el-form-item label="模版名称：" prop="templateName">
              <el-input placeholder="请输入模版名称" v-model="queryParams.templateName" v-if="isBtnShow"></el-input>
              <span v-else>{{queryParams.templateName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="添加人：" prop="productClass">{{queryParams.createUser}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="添加时间：" prop="productClass">{{queryParams.createDate|dateFilter}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="模版状态：">
              <el-select v-model="queryParams.flag" placeholder="请选择" v-if="isBtnShow">
                <el-option label="启用" :value="true"></el-option>
                <el-option label="禁用" :value="false"></el-option>
              </el-select>
              <span v-else>{{queryParams.flag?'启用':'禁用'}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="当前版本号：" prop="productClass">{{queryParams.version}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最后更新时间：" prop="productClass">{{queryParams.editDate|dateFilterD}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="product-status" style="margin-top:20px">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="item in tempDetailsList"
          :key="item.name"
        >
          <div
            style="padding:20px 20px 0 20px;background:#fff;"
            v-show="activeName === 'priceInformation'"
          >
            <el-row>
              <el-col :span="24">
                <el-button @click="onAddBrand" type="primary" plain>添加协议价品牌</el-button>
                <el-button @click="onAddSeries" type="primary" plain>添加协议价系列</el-button>
                <el-button @click="onAddProduct" type="primary" plain>添加协议价产品</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="operation" style="padding:20px;">
            <el-tabs
              v-model="priceActiveName"
              @tab-click="handleClickTabs"
              type="card"
              v-show="activeName === 'priceInformation'"
            >
              <el-tab-pane
                :label="item.title"
                :name="item.name"
                class="tab-text"
                v-for="item in priceList"
                :key="item.name"
              >
                <el-form :model="searchQueryParams">
                  <el-row :gutter="20">
                    <el-col :span="4">
                      <el-form-item>
                        <el-select v-model="searchQueryParams.name" @change="onChangeSearch">
                          <el-option
                            label="品牌"
                            value="brandName"
                            v-if="activeName!=='customerList'"
                          ></el-option>
                          <el-option
                            label="系列"
                            value="seriesName"
                            v-if="priceActiveName==='priceseries'&&activeName!=='customerList'"
                          ></el-option>
                          <!-- <el-option
                            label="系列组"
                            value="bgName"
                            v-if="priceActiveName==='priceseries'&&activeName!=='customerList'"
                          ></el-option>-->
                          <el-option
                            label="型号"
                            v-if="priceActiveName==='priceproduct'&&activeName!=='customerList'"
                            value="proModel"
                          ></el-option>
                          <el-option
                            label="产品名称"
                            v-if="priceActiveName==='priceproduct'&&activeName!=='customerList'"
                            value="proName"
                          ></el-option>
                          <el-option
                            label="订货号"
                            v-if="priceActiveName==='priceproduct'&&activeName!=='customerList'"
                            value="proOrdernum"
                          ></el-option>
                          <el-option label="状态" value="flag" v-if="activeName!=='customerList'"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item>
                        <el-input
                          v-model="params.value"
                          v-show="searchQueryParams.name!=='flag'"
                          placeholder="请输入关键词"
                        ></el-input>
                        <el-select v-model="params.value" v-show="searchQueryParams.name==='flag'">
                          <el-option label="停用" value="0"></el-option>
                          <el-option label="启用" value="1"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item>
                        <el-button type="primary" @click="onSearch">搜索</el-button>
                         <el-button @click="onReset">重置</el-button>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" style="text-align:right;">
                      <el-button @click="onDelete" type="primary" plain>批量删除</el-button>
                    </el-col>
                  </el-row>
                </el-form>
                <el-table
                  ref="multipleTable"
                  :data="informationTable"
                  tooltip-effect="dark"
                  :header-cell-style="tableHeader"
                  @selection-change="handleSelectionChangeInform"
                  height="486"
                  border
                >
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column prop="brandName" label="品牌"></el-table-column>
                  <!-- <el-table-column prop="bgName" label="系列组" v-if="priceActiveName==='priceseries'"></el-table-column> -->
                  <el-table-column
                    prop="seriesName"
                    label="系列"
                    v-if="priceActiveName!=='priceBrand'"
                  ></el-table-column>
                  <el-table-column
                    prop="proName"
                    label="产品名称"
                    v-if="priceActiveName==='priceproduct'"
                  ></el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="proModel"
                    label="型号"
                    v-if="priceActiveName==='priceproduct'"
                  ></el-table-column>
                  <el-table-column
                    prop="proOrdernum"
                    label="订货号"
                    v-if="priceActiveName==='priceproduct'"
                  ></el-table-column>
                  <el-table-column label="协议设置">
                    <template slot-scope="scope">{{scope.row.templateType===1?'折扣价':'加价率'}}</template>
                  </el-table-column>
                  <el-table-column label="比例">
                    <template slot-scope="scope">{{scope.row.templateRate / 100 | perCentFilter}}</template>
                  </el-table-column>
                  <el-table-column
                    prop="proPrice"
                    label="产品面价"
                    v-if="priceActiveName==='priceproduct'"
                  ></el-table-column>
                  <el-table-column prop="usableMoney" label="状态 ">
                    <template slot-scope="scope">{{scope.row.flag?'启用':'停用'}}</template>
                  </el-table-column>
                  <el-table-column label="添加人">
                    <template slot-scope="scope">{{scope.row.createUser|| '--'}}</template>
                  </el-table-column>
                  <el-table-column prop="createDate" label="添加时间">
                    <template slot-scope="scope">{{scope.row.createDate|dateFilterD}}</template>
                  </el-table-column>
                  <el-table-column prop="editDate" label="更新时间">
                    <template slot-scope="scope">{{scope.row.editDate|dateFilterD}}</template>
                  </el-table-column>
                  <el-table-column prop="usableMoney" label="操作" width="150">
                    <template slot-scope="scope">
                      <el-button type="text" @click="onCompile(scope.row)">编辑</el-button>
                      <el-button type="text" @click="onDelete(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
            <div v-show="activeName !== 'priceInformation'">
              <el-form>
                <el-row :gutter="20">
                  <el-col :span="10">
                    <el-form-item label="客户名称：" label-width="85px">
                      <el-input v-model="searchQueryParams.cusNmae"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item>
                      <el-button type="primary" @click="onSearch">搜索</el-button>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="text-align:right;">
                    <el-button type="primary" plain @click="bulkUpdate(2)">批量更新</el-button>
                    <el-button type="primary" plain @click="batchunbundling(2)">批量解绑</el-button>
                  </el-col>
                </el-row>
              </el-form>
              <el-table
                border
                ref="onlineTableRefs"
                :data="onlineTable"
                :header-cell-style="tableHeader"
                element-loading-text="拼命加载中请稍后..."
                v-loading="loadingOnlineTable"
                element-loading-spinner="el-icon-loading"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="cusCode" label="客户编号"></el-table-column>
                <el-table-column prop="cusName" label="客户名称"></el-table-column>
                <el-table-column prop="type" label="贸易总额"></el-table-column>
                <el-table-column prop="type" label="签订合同数量"></el-table-column>
                <el-table-column prop="usableMoney" label="坏账"></el-table-column>
                <el-table-column prop="version" label="使用版本号"></el-table-column>
                <el-table-column label="绑定时间">
                  <template slot-scope="scope">{{scope.row.createDate|dateFilterD}}</template>
                </el-table-column>
                <el-table-column label="更新时间">
                  <template slot-scope="scope">{{scope.row.editDate|dateFilterD}}</template>
                </el-table-column>
                <el-table-column prop="usableMoney" label="操作" width="150px">
                  <template slot-scope="scope">
                    <el-button
                      :disabled="scope.row.state===0"
                      @click="batchunbundling(1,scope.row)"
                    >解绑</el-button>
                    <el-button
                      type="primary"
                      @click="bulkUpdate(1,scope.row)"
                      :disabled="queryParams.version===scope.row.version?true:false"
                      plain
                    >更新</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="height:50px;padding:20px 20px 0">
              <pagination
                :total="total"
                :currentPage="currentPage"
                :pageSize="pageSize"
                @handleCurrentChange="handleCurrentChange"
                @handleSizeChange="handleSizeChange"
              ></pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-------------- 批量更新/解绑 -------------->
    <unbundle-and-update
      @getOnlineList="getOnlineList"
      :title="title"
      :content="content"
      ref="unbundleAndUpdateRef"
    ></unbundle-and-update>
    <!-------------- 编辑品牌/添加协议价品牌 -------------->
    <price-brand-add @getListBrand="getListBrand" ref="priceBrandAddRefs"></price-brand-add>
    <!-------------- 编辑系列 -------------->
    <price-series-edit ref="priceSeriesEditRefs" @getListSeries="getListSeries"></price-series-edit>
    <!-------------- 编辑产品 -------------->
    <price-product-edit ref="priceProductEditRefs" @getListProduct="getListProduct"></price-product-edit>
    <!-------------- 添加协议价系列 -------------->
    <price-series-add @getListSeries="getListSeries" ref="priceSeriesAddRefs"></price-series-add>
    <!-------------- 添加协议价产品 -------------->
    <price-product-add @getListProduct="getListProduct" ref="priceProductAddRefs"></price-product-add>
    <!-------------- 绑定弹窗 -------------->
    <binding-customer @onUpdate="getOnlineList" ref="bindingCustomerRef"></binding-customer>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
import {
  queryEditById,
  updateTemplate,
  priceBrandqueryPageAll,
  updateByFlagBrandSeriesProduct,
  priceSeriesqueryPageAll,
  priceProductqueryPageAll,
  queryAllCustomerPriceTemplate
} from '@/api/customer/customerManage'
import priceBrandAdd from './dialog/priceBrandAdd'
import priceSeriesEdit from './dialog/priceSeriesEdit'
import priceProductEdit from './dialog/priceProductEdit'
import priceSeriesAdd from './dialog/priceSeriesAdd'
import priceProductAdd from './dialog/priceProductAdd'
import bindingCustomer from './dialog/bindingCustomer'
import unbundleAndUpdate from './dialog/unbundleAndUpdate'
import { priceList } from './utils/data'
export default {
  components: {
    pagination,
    priceBrandAdd,
    'price-series-edit': priceSeriesEdit,
    'price-product-edit': priceProductEdit,
    'price-series-add': priceSeriesAdd,
    'price-product-add': priceProductAdd,
    'binding-customer': bindingCustomer,
    'unbundle-and-update': unbundleAndUpdate
  },
  data() {
    return {
      isBtnShow: true,
      queryParams: {},
      searchQueryParams: {},
      params: {},
      informationTable: [], // 协议价信息列表
      total: 0,
      currentPage: 1, // 页码
      pageSize: 30, // 当前页数
      activeName: 'priceInformation',
      tempDetailsList: [
        { title: '协议价信息', name: 'priceInformation' },
        { title: '在用客户列表', name: 'customerList' }
      ],
      priceList: [],
      priceActiveName: 'priceBrand',
      onlineTable: [],
      checkList: [], // 在用列表选中的数据
      checkListInform: [], // 协议价信息
      loadingOnlineTable: false,
      isUpdate: true,
      rules: {
        templateName: [
          { required: true, message: '模板名称不能为空', trigger: 'blur' }
        ]
      },
      content: '', // 批量绑定,更新和单个绑定和更新弹窗内容
      title: '' // 批量绑定,更新和单个绑定和更新弹窗标题
    }
  },
  created() {
    // 从客户详情协议价模板跳转至在线客户列表,操作更新客户模版
    if (this.$route.params.goTo === 'customerList') {
      this.activeName = 'customerList'
      this.queryParams.templateName = this.$route.params.templateName
      this.getOnlineList()
    }
    this.priceList = priceList
    this.getEdit()
    this.getListBrand()
  },
  methods: {
    // 根据id获取详情信息
    getEdit() {
      queryEditById(this.$route.query.id)
        .then(res => {
          if (res.data.code === 200) {
            this.queryParams = res.data.obj.customerPriceTemplateList
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 切换条件清空
    onChangeSearch() {
      this.params = { value: '' }
    },
    // 搜索
    onSearch() {
      if (this.activeName === 'customerList') {
        // 在线列表
        this.pageSize = 30
        this.currentPage = 1
        this.getOnlineList()
      } else {
        if (this.priceActiveName === 'priceBrand') {
          // 品牌
          this.pageSize = 30
          this.currentPage = 1
          this.getListBrand()
        } else if (this.priceActiveName === 'priceseries') {
          // 系列
          this.pageSize = 30
          this.currentPage = 1
          this.getListSeries()
        } else if (this.priceActiveName === 'priceproduct') {
          // 产品
          this.pageSize = 30
          this.currentPage = 1
          this.getListProduct()
        }
      }
    },
    // 重置
    onReset() {
      this.pageSize = 30
      this.currentPage = 1
      this.searchQueryParams = []
      this.params.value = ''
      this.onSearch()
    },
    // 品牌,系列,产品tabs
    handleClickTabs(tab) {
      this.searchQueryParams = { name: '' }
      this.params = { value: '' }
      this.priceActiveName = tab.name
      this.onSearch()
    },
    // 协议价品牌列表
    getListBrand() {
      const params = {
        criteriaVoList: this.$queryParams(this.searchQueryParams, this.params),
        queryPageName: ''
      }
      priceBrandqueryPageAll(
        this.$route.query.id,
        this.currentPage,
        this.pageSize,
        params
      )
        .then(res => {
          if (res.data.code === 200) {
            this.informationTable = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 协议价系列列表
    getListSeries() {
      const params = {
        criteriaVoList: this.$queryParams(this.searchQueryParams, this.params),
        queryPageName: ''
      }
      priceSeriesqueryPageAll(
        this.$route.query.id,
        this.currentPage,
        this.pageSize,
        params
      )
        .then(res => {
          if (res.data.code === 200) {
            this.informationTable = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 协议价产品列表
    getListProduct() {
      const params = {
        criteriaVoList: this.$queryParams(this.searchQueryParams, this.params),
        queryPageName: ''
      }
      priceProductqueryPageAll(
        this.$route.query.id,
        this.currentPage,
        this.pageSize,
        params
      )
        .then(res => {
          if (res.data.code === 200) {
            this.informationTable = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 编辑
    onEdit() {
      this.isBtnShow = false
    },
    // 保存
    onSave() {
      this.$refs.queryParamsRefs.validate(valid => {
        if (valid) {
          this.isBtnShow = true
          const params = {
            flag: this.queryParams.flag,
            templateName: this.queryParams.templateName,
            id: this.queryParams.id
          }
          updateTemplate(params)
            .then(res => {
              if (res.data.code === 200) {
                this.queryParams = params
                this.getEdit()
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      })
    },
    // 协议价品牌/系列/产品删除
    onDelete(row) {
      let arrList = []
      if (this.checkListInform.length > 0) {
        // 批量删除
        arrList = this.checkListInform.map(i => i.id)
      } else {
        // 列表单个删除
        arrList.push(row.id)
      }
      updateByFlagBrandSeriesProduct(arrList)
        .then(res => {
          if (res.data.code === 200) {
            this.onSearch()
            this.$message.success('操作成功!')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 列表品牌,系列,产品编辑
    onCompile(row) {
      if (this.priceActiveName === 'priceBrand') {
        // 品牌
        this.$refs.priceBrandAddRefs.priceBrandAddInitial(2, row)
      } else if (this.priceActiveName === 'priceseries') {
        // 系列
        this.$refs.priceSeriesEditRefs.priceSeriesEditInitial(1, row)
      } else if (this.priceActiveName === 'priceproduct') {
        // 产品
        this.$refs.priceProductEditRefs.priceProductEditInitial(1, row)
      }
    },
    // 在线用户列表
    getOnlineList() {
      this.loadingOnlineTable = true
      let params = {}
      if (this.searchQueryParams.cusNmae) {
        params = {
          criteriaVoList: [
            {
              collection: true,
              column: 'cusName',
              value: this.searchQueryParams.cusNmae,
              valueType: ''
            }
          ],
          queryPageName: ''
        }
      } else {
        params = {
          criteriaVoList: [],
          queryPageName: ''
        }
      }
      queryAllCustomerPriceTemplate(
        this.queryParams.templateName,
        this.currentPage,
        this.pageSize,
        params
      )
        .then(res => {
          if (res.data.code === 200) {
            this.loadingOnlineTable = false
            this.onlineTable = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 在线列表数据选中
    handleSelectionChange(row) {
      this.checkList = row
    },
    // 协议价信息数据选中
    handleSelectionChangeInform(row) {
      this.checkListInform = row
    },
    // 协议价信息/在用客户列表tabs
    handleClick(tab) {
      this.activeName = tab.name
      this.priceActiveName = 'priceBrand'
      if (this.activeName === 'customerList') {
        // 在线列表
        this.getOnlineList()
      } else if (this.activeName === 'priceInformation') {
        this.getListBrand()
      }
    },
    // 列表表头样式
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.onSearch()
      if (this.activeName === 'customerList') {
        // 在线用户列表
        this.getOnlineList()
      }
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.onSearch()
      if (this.activeName === 'customerList') {
        // 在线用户列表
        this.getOnlineList()
      }
    },
    // 添加协议价品牌
    onAddBrand() {
      this.$refs.priceBrandAddRefs.priceBrandAddInitial(3)
    },
    // 添加协议价系列
    onAddSeries() {
      this.$refs.priceSeriesAddRefs.priceSeriesAddInitial(2)
    },
    // 添加协议价产品
    onAddProduct() {
      this.$refs.priceProductAddRefs.priceProductAddInitial(2)
    },
    // 绑定
    onBinding() {
      this.$refs.bindingCustomerRef.onInitial(this.$route.query.id)
    },
    // 批量更新
    bulkUpdate(type, row) {
      // type=1是列表的更新,2是批量更新
      if (type === 1) {
        const arrList = []
        arrList.push(row)
        this.title = '更新'
        this.content = '确定更新该名客户协议价模版？'
        this.$refs.unbundleAndUpdateRef.onInitial(1, arrList)
      } else {
        this.title = '批量更新'
        this.content = '确定更新' + this.checkList.length + '名客户协议价模版？'
        this.$refs.unbundleAndUpdateRef.onInitial(1, this.checkList)
      }
    },
    // 批量解绑
    batchunbundling(type, row) {
      // type=1是列表的解绑,2是批量解绑
      if (type === 1) {
        const arrList = []
        arrList.push(row)
        this.title = '解绑'
        this.content = '确定解绑该名客户协议价模版？'
        this.$refs.unbundleAndUpdateRef.onInitial(2, arrList)
      } else {
        this.title = '批量解绑'
        this.content = '确定解绑' + this.checkList.length + '名客户协议价模版？'
        this.$refs.unbundleAndUpdateRef.onInitial(2, this.checkList)
      }
    }
  }
}
</script>
<style scoped>
.el-tabs__header .is-top {
  margin-top: 0px !important;
}
</style>
